import {Controller} from '@stubhub/react-store-provider';
import {currentLocaleSelector, storeIdSelector} from '../store/gsConfig/selectors';
import {shstoreIdMappings} from '@stubhub/general-utils';
import {getSelectedCurrencyCode} from '@stubhub/react-currency-exchange';
import getStoreCurrencyCode from '@stubhub/react-store-default-currency';
import {isAdvisoryCurrencyFFEnabledSelector, isAdvisoryCurrencyOptOutFFEnabledSelector} from '../store/advisoryCurrency/selectors';
import {
  ancestorsSelector,
  connectionsSelector,
  daysToEventSelector,
  eventCountrySelector,
  eventDateUTCSelector,
  eventIdSelector,
  eventNameSelector,
  genreSelector,
  imageURLSelector,
  inventoryMarketSelector,
  numFeaturesSelector,
  numRestrictionsSelector,
  onSaleDateSelector
} from '../store/eventData/selectors';
import {getSellFlowStart} from './track-utils';
import {SELL_FLOW_START} from './sell-flow-start-enum';
import {
  errorSelector, 
  allFulfillmentMethodsSelector, 
  ticketTypeSelector,
  ticketFulfillmentMethodSelector,
  ticketDeliverNowSelector,
  faceValueSelector,
  sellerTypeSelector,
  paymentMethodSelector,
  numTicketsSelector,
  ticketCurrencySelector,
  ticketPriceSelector
} from '../store/sellTicket/selectors';
import {listingIdCreatedSelector} from '../store/createListing/selectors';
import {
  featuresQuantitySelector,
  restrictionsQuantitySelector,
  connectionsMapperSelector,
  limitationsQuantitySelector
} from '../store/seatDetails/selector';

const NAMESPACE = 'tracking';

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps: (state) => {
    const storeId = storeIdSelector(state);
    const {site: storeCountry} = shstoreIdMappings[storeId] || {};
    const isAdvisoryOptOutEnabled =
      isAdvisoryCurrencyOptOutFFEnabledSelector(state);
    let advisoryCurrency = getSelectedCurrencyCode();
    if (isAdvisoryOptOutEnabled && !advisoryCurrency) {
      advisoryCurrency = getStoreCurrencyCode(storeId);
    }
    let sellFlowStart = SELL_FLOW_START.OTHER;
    if (__CLIENT__ && document) {
      const {referrer} = document;
      sellFlowStart = getSellFlowStart(referrer);
    }

    return {
      storeId,
      storeCountry,
      locale: currentLocaleSelector(state),
      isAdvisoryCurrencyEnabled: isAdvisoryCurrencyFFEnabledSelector(state),
      advisoryCurrency,
      sellFlowStart,
      eventId: eventIdSelector(state),
      eventName: eventNameSelector(state),
      daysToEvent: daysToEventSelector(state),
      genre: genreSelector(state),
      inventoryMarket: inventoryMarketSelector(state),
      ancestors: ancestorsSelector(state),
      fulfillmentMethods: allFulfillmentMethodsSelector(state),
      countryCode: eventCountrySelector(state),
      errorName: errorSelector(state),
      medium: ticketTypeSelector(state),
      fulFillmentMethod: ticketFulfillmentMethodSelector(state),
      deliveryNow: ticketDeliverNowSelector(state),
      numTickets: numTicketsSelector(state),
      faceValue: faceValueSelector(state),
      ticketPrice: ticketPriceSelector(state),
      ticketCurrency: ticketCurrencySelector(state),
      numFeatures: numFeaturesSelector(state),
      numRestrictions: numRestrictionsSelector(state),
      sellerType: sellerTypeSelector(state),
      paymenMethod: paymentMethodSelector(state),
      connections: connectionsSelector(state),
      listingId: listingIdCreatedSelector(state),
      imageURL: imageURLSelector(state),
      onSaleDate: onSaleDateSelector(state),
      eventDateUTC: eventDateUTCSelector(state),
      featuresQuantity: featuresQuantitySelector(state),
      restrictionsQuantity: restrictionsQuantitySelector(state),
      connected: connectionsMapperSelector(state),
      limitationsQuantity: limitationsQuantitySelector(state)
    };
  }
});

export default controller;
